import { ImportTemplateListResponse } from "../../../shared/entities/ImportTemplateListResponse";
import { TranslationService } from "../../../../services/TranslationService";
import ImportTemplateEditBase, {
  ImportTemplateComponentProps
} from "./ImportTemplateEditBase";
import EditItem from "./Components/EditItem";
import { TextEditor } from "../../../shared/components/Editors";
import Collapsable from "../../../shared/bootstrap/Collapsable";
import { useState } from "react";

const ImportTemplateEditDictionary = ({
  data,
  reload,
  entityId = undefined
}: {
  data?: ImportTemplateListResponse.Item;
  reload: () => void;
  importsList?: ImportTemplateListResponse;
  entityId?: number;
}) => {
  const [showDetail, setShowDetail] = useState(false);
  const { translate } = TranslationService;

  const Header = () => {
    return (
      <div className="m-3">
        <h5 className="mb-4">{translate.DictionaryImportSettings}</h5>
        <details className="mt-3" onClick={() => setShowDetail((x) => !x)}>
          <summary className="ps-1 mb-2">
            <h6 style={{ display: "unset" }}>
              {TranslationService.translate.SeeTheRequirementsOfTheFileToImport}
            </h6>
          </summary>
        </details>
        <Collapsable show={showDetail}>
          {TranslationService.translate.RequirementsOfTheFileToImport.split(
            "\n"
          ).map((x, i) => (
            <div key={i} className="text-muted ms-3">
              {x}
            </div>
          ))}
        </Collapsable>
      </div>
    );
  };

  const AdvancedOptions = ({
    data,
    updateModel
  }: ImportTemplateComponentProps) => (
    <EditItem label={<>{translate.SendResultsTo}</>}>
      <TextEditor
        onChange={updateModel("EmailReturn")}
        defaultValue={data?.EmailReturn}
      />
    </EditItem>
  );
  return (
    <div className="container">
      <ImportTemplateEditBase
        key="DictionaryTemplate"
        entityId={entityId}
        Header={Header}
        reload={reload}
        requiredFieldIds={[]}
        data={data}
        AdvancedOptions={AdvancedOptions}
        cancelBtn
      />
    </div>
  );
};

export default ImportTemplateEditDictionary;
